import React from 'react';

import s from './Footer.module.scss';
import { FooterTop } from './footerTop/FooterTop';
import { Button } from '@components/shared/button/Button';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '@configs/routeConstants';
import { getCurrentThemeFromDom, normalizeTheme } from '@configs/themeAssets';
import { useCompanyTheme } from '@hooks/useCompanyTheme';
import { getWhiteLabelJsonThemeKey } from '@utils/companyTheme';
import classNames from 'clsx';
import T from '@data/text/footer.json';
import { isMentalHealthEnabled } from '@configs/features';

const Footer: React.FC = () => {
  const { pathname } = useLocation();
  const isMentalHealth = isMentalHealthEnabled && pathname.startsWith(ROUTES.myHealth.mentalHealth);
  const isMyHealth =
    (pathname === ROUTES.myHealth.root || pathname.startsWith(`${ROUTES.myHealth.root}/`)) &&
    !isMentalHealth;
  const company = useCompanyTheme();

  const theme = getCurrentThemeFromDom() ?? normalizeTheme(company) ?? null;

  const themeKey = getWhiteLabelJsonThemeKey(theme);
  const brandText = T.brandTextByTheme[themeKey];
  const disclaimerTemplate = T.disclaimerByTheme[themeKey];
  const disclaimerText = disclaimerTemplate.replace('{{brandText}}', brandText);
  const isIngos = themeKey === 'ingosstrakh';

  return (
    <footer
      className={classNames(
        s.footer,
        isMyHealth && s.myHealthMobileGap,
        isMentalHealth && s.mentalHealthFooter,
      )}
    >
      <FooterTop />

      {/* ─────────── BOTTOM ─────────── */}
      <div className={s.footerBottom}>
        <div className={s.container}>
          <div className={s.footerBottomWrapper}>
            <Link to={ROUTES.documents} className={s.documentsButton}>
              <Button className={s.documentsButton} variant="compact">
                <span className={s.link}>{T.buttons.documents}</span>
              </Button>
            </Link>
            <div className={s.textSection}>
              <span className={s.text}>{disclaimerText}</span>
              {isIngos ? (
                ''
              ) : (
                <span className={s.subtext}>
                  {T.copyright.line1} {T.copyright.line2}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
